import React from 'react';

export const ErrorContext = React.createContext();